time_tab_cont()
plan_slider()
page_scroll()

function time_tab_cont() {
    $(function () {
        $('.tab-nav li').on('click', function () {

            //nav
            $('.tab-nav li').removeClass('active')
            $(this).addClass('active')

            //cont
            var active_tab = $(this).attr('data-tab')
            $('.tab-cont > div').removeClass('active')
            $('.tab-cont > div').each(function () {
                if ($(this).attr('class') == active_tab) {
                    $(this).addClass('active')
                }
            })
        })
    })
}

function plan_slider() {
    $('.plan .slider').slick({
        accessibility: false,
        prevArrow: false,
        nextArrow: false,
        dots: true,
        autoplay: true,
    }
    )
}


function page_scroll() {
    $(function() {
        $('a[href^="#"]').on('click', function () {
            var speed = 400;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top;
            $('body,html').animate({ scrollTop: position }, speed, 'swing');
            return false;
        });
    });
}